import type { ReactNode } from "react"
import styles from "./Button.module.scss"

type Props = {
  variant?: "primary" | "secondary" | "tertiary"
  /**
   * "small" is the design system's "Button … Small": a 14px semibold label that
   * hugs its content, for buttons that sit beside content rather than driving a
   * whole page. The default stretches to fill its flex row.
   */
  size?: "large" | "small"
  onClick?: () => void
  disabled?: boolean
  // Marks the button unavailable while keeping it focusable + announced (unlike
  // native `disabled`, which AT skips) — use when the user needs to hear WHY it's
  // unavailable. The caller must guard its onClick. Pair with `describedBy`.
  ariaDisabled?: boolean
  describedBy?: string
  type?: "button" | "submit"
  children: ReactNode
}

export function Button({
  variant = "primary",
  size = "large",
  onClick,
  disabled,
  ariaDisabled,
  describedBy,
  type = "button",
  children,
}: Props) {
  return (
    <button
      type={type}
      className={`${styles.button} ${styles[variant]} ${styles[size]}`}
      onClick={onClick}
      disabled={disabled}
      aria-disabled={ariaDisabled}
      aria-describedby={describedBy}
    >
      {children}
    </button>
  )
}
